import { apiSlice, TagType } from "@/features/api/apiSlice.ts"
import {
  type CropPlantingEvent,
  type CropPlantingEventInput,
} from "@/features/events/crop-planting-events/types/crop-planting-event.ts"

const CROP_PlANTING_EVENTS_BASE_URL = "/crop-planting-events/"

export const CropPlantingEventsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllCropPlantingEvents: builder.query<CropPlantingEvent[], void>({
      query: () => ({
        url: CROP_PlANTING_EVENTS_BASE_URL,
      }),
      providesTags: () => [{ type: TagType.CropPlantingEvents, id: "LIST" }],
    }),
    createCropPlantingEvent: builder.mutation<
      CropPlantingEvent,
      CropPlantingEventInput
    >({
      query: (cropEvent) => {
        return {
          url: CROP_PlANTING_EVENTS_BASE_URL,
          method: "POST",
          body: cropEvent,
        }
      },
      invalidatesTags: [
        { type: TagType.CropPlantingEvents, id: "LIST" },
        { type: TagType.CropPlantingCalendars },
      ],
    }),
    getCropPlantingEventById: builder.query<CropPlantingEvent, string>({
      query: (id) => ({
        url: `${CROP_PlANTING_EVENTS_BASE_URL}${id}/`,
      }),
      providesTags: (_result, _error, id) => [
        { type: TagType.CropPlantingEvents, id },
      ],
    }),
    updateCropPlantingEvent: builder.mutation<
      CropPlantingEvent,
      { id: CropPlantingEvent["id"] } & Partial<CropPlantingEvent>
    >({
      query: ({ id, ...patch }) => {
        return {
          url: `${CROP_PlANTING_EVENTS_BASE_URL}${id}/`,
          method: "PATCH",
          body: patch,
        }
      },
      invalidatesTags: (_result, _error, { id }) => [
        { type: TagType.CropPlantingEvents, id },
        { type: TagType.CropPlantingEvents, id: "LIST" },
      ],
    }),
    deleteCropPlantingEvent: builder.mutation<void, Partial<CropPlantingEvent>>(
      {
        query: (cropEvent) => {
          return {
            url: `${CROP_PlANTING_EVENTS_BASE_URL}${cropEvent.id}/`,
            method: "DELETE",
          }
        },
        invalidatesTags: [{ type: TagType.CropPlantingEvents, id: "LIST" }],
      },
    ),
  }),
})

export const {
  useGetAllCropPlantingEventsQuery,
  useCreateCropPlantingEventMutation,
  useGetCropPlantingEventByIdQuery,
  useUpdateCropPlantingEventMutation,
  useDeleteCropPlantingEventMutation,
} = CropPlantingEventsApi
